/** Guest portal role; legacy API/DB may still return "customer". */
export function isGuestPortalRole(role) {
  const r = role == null ? '' : String(role).trim().toLowerCase();
  return r === 'guest' || r === 'customer';
}
